module.exports = __webpack_public_path__ + "static/menu-ikeda-sengyo-min-f7452d8b65a3023c35be2ba2085795a6.jpg";